<template>
  <div class="layout-px-spacing">
    <teleport to="#breadcrumb">
      <ul class="navbar-nav flex-row">
        <li>
          <div class="page-header">
            <nav class="breadcrumb-one" aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:;">{{ $t('Setting') }}</a></li>
                <li class="breadcrumb-item active" aria-current="page"><span>{{ $t('User System') }}</span></li>
              </ol>
            </nav>
          </div>
        </li>
      </ul>
    </teleport>

    <div class="row layout-top-spacing">
      <div class="col-xl-12 col-lg-12 col-md-12 col-12 layout-spacing">
        <div class="panel br-4">
          <div class="panel-body">
            <div class="row">
              <div class="col-12 col-md-6">
                <router-link :to="{ name: 'UserSystemForm' }" class="btn btn-primary mb-4 me-2">
                  {{ $t('Add Data') }}
                </router-link>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group mb-0">
                  <div class="input-group mb-4">
                    <span class="input-group-text">
                      <div class="icon-container">
                        <i class="fas fa-search"></i>
                      </div>
                    </span>
                    <input type="text" v-model="search" class="form-control" @keyup.enter="userSystemStore.searchData()"
                      :placeholder="$t('Enter') + ' ' + $t('Search')" />
                  </div>
                </div>
              </div>
            </div>
            <template v-if="isLoadingTable">
              <div class="row">
                <div class="col-12">
                  <Skeletor width="100%" height="800" as="div" />
                </div>
              </div>
            </template>
            <template v-else>
              <div class="table-responsive">
                <table role="table" aria-busy="false" aria-colcount="5" class="table table-bordered" id="__BVID__415">
                  <thead role="rowgroup">
                    <tr role="row" class="table-dark">
                      <th role="columnheader" scope="col" class="text-black text-center w-90 ">
                        <div>{{ $t('Action') }}</div>
                      </th>
                      <th role="columnheader" scope="col" class="text-black text-center">
                        <div>{{ $t('Name') }}</div>
                      </th>
                      <th role="columnheader" scope="col" class="text-black text-center">
                        <div>{{ $t('Phone') }}</div>
                      </th>
                      <th role="columnheader" scope="col" class="text-black text-center">
                        <div>{{ $t('Email') }}</div>
                      </th>
                      <th role="columnheader" scope="col" class="text-black text-center">
                        <div>{{ $t('Username') }}</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody role="rowgroup">
                    <tr v-for="item in listData" :key="item.user_id" role="row">
                      <td role="cell" class="text-center">
                        <ul class="table-controls">
                          <li>
                            <a @click="deleteData(item.user_id)" href="javascript:void(0)" data-bs-toggle="tooltip"
                              :title="$t('Delete')">
                              <i class="fas fa-trash text-danger"></i>
                            </a>
                          </li>
                          <li>
                            <router-link :to="{ name: 'UserSystemForm', query: { act: 'edit', id: item.user_id } }"
                              data-bs-toggle="tooltip" :title="$t('Edit')">
                              <i class="fas fa-edit text-info"></i>
                            </router-link>
                          </li>
                          <li>
                            <router-link :to="{ name: 'UserSystemForm', query: { act: 'view', id: item.user_id } }"
                              data-bs-toggle="tooltip" :title="$t('View')">
                              <i class="fas fa-eye text-secondary"></i>
                            </router-link>
                          </li>
                        </ul>

                      </td>
                      <td role="cell">{{ item.name }}</td>
                      <td role="cell">{{ item.phone }}</td>
                      <td role="cell">{{ item.email }}</td>
                      <td role="cell">{{ item.username }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>
            <div class="row">
              <div class="col-md-8 offset-md-4 col-12">
                <Pagination :key="componentKey" :pagination="pagination" v-if="listData.length > 0"
                  @get-paging="getPaging" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useUserSystemStore } from '@/store/setting/userSystemStore';
import Pagination from '@/components/elemets/pagination.vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

// init
const userSystemStore = useUserSystemStore();
userSystemStore.getData();
const { search, listData, pagination, page, componentKey, isLoadingTable, isSuccess } = storeToRefs(userSystemStore);

// pagination
const getPaging = async (paging) => {
  page.value = paging;
  await userSystemStore.getDataByPaging();
}

// delete
const deleteData = async (id) => {
  const swalWithBootstrapButtons = window.Swal.mixin({
    confirmButtonClass: 'btn btn-danger me-3',
    cancelButtonClass: 'btn btn-dark',
    buttonsStyling: false
  });

  swalWithBootstrapButtons
    .fire({
      title: t('Are you sure?'),
      text: t('Check your data again'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('Delete'),
      cancelButtonText: t('Cancel'),
      padding: '2em'
    }).then(async (result) => {
      if (result.value) {
        await userSystemStore.deleteData(id);
        if (isSuccess.value) {
          new window.Swal(t('Success'), t('Data has been deleted'), 'success');
        } else {
          new window.Swal(t('Failed'), t('Data failed to delete'), 'error');
        }
        await userSystemStore.getData();
      }
    });
}

</script>
